import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

/**
 * Igual que el comportamiento por defecto de Angular (reusar el componente si
 * la ruta es la misma), salvo en las rutas que declaran en `data.recrearCon`
 * los parámetros de la URL que leen al iniciar: si alguno cambia, el
 * componente se vuelve a crear.
 *
 * Sin esto, un link a la misma pantalla con otros filtros (p. ej. de Precios a
 * Precios de un producto) cambiaba la URL pero el listado seguía como estaba,
 * porque esos componentes leen los parámetros una sola vez en `ngOnInit`.
 */
export class ReusoConParametros extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    futura: ActivatedRouteSnapshot,
    actual: ActivatedRouteSnapshot,
  ): boolean {
    if (!super.shouldReuseRoute(futura, actual)) return false;
    const claves = futura.routeConfig?.data?.['recrearCon'] as
      | string[]
      | undefined;
    if (!claves?.length) return true;
    return claves.every(
      (k) => futura.queryParamMap.get(k) === actual.queryParamMap.get(k),
    );
  }
}
